import { useGetTranslations } from './get-translations/hook';

export const Translations = {
  useGetTranslations,
};
